module.exports = __webpack_public_path__ + "img/mic13.798aacdf.jpg";